<template>
  <div class="house-importer-import-charges-stage">
    <div class="house-importer-import-charges-stage__row">
      <div class="house-importer-import-charges-stage__col house-importer-import-charges-stage__col50">
        <InfoPanel class="house-importer-import-charges-stage__col-content" :import-info="importInfo" @update-stage="$emit('update-stage')" :tariffs="tariffs" :apartmentsType.sync="apartmentsType"/>
      </div>
      <div class="house-importer-import-charges-stage__col house-importer-import-charges-stage__col50">
        <ChargesParameters class="house-importer-import-charges-stage__col-content" :import-info="importInfo" :tariffs="tariffs" :apartmentsType.sync="apartmentsType"/>
        <CheckTotalCharges class="house-importer-import-charges-stage__col-content" :import-info="importInfo" :tariffs="tariffs" :apartmentsType.sync="apartmentsType"/>
      </div>
    </div>

    <div class="house-importer-import-charges-stage__row">
      <div class="house-importer-import-charges-stage__col">
        <CheckCharges class="house-importer-import-charges-stage__col-content" :import-info="importInfo" :tariffs="tariffs" :apartmentsType.sync="apartmentsType"/>
      </div>
    </div>

    <div class="house-importer-import-charges-stage__row">
      <div class="house-importer-import-charges-stage__col">
        <EditDevices class="house-importer-import-charges-stage__col-content" :import-info="importInfo" :tariffs="tariffs" :apartmentsType.sync="apartmentsType"/>
      </div>
    </div>
  </div>
</template>

<script>
  import InfoPanel from "./panels/InfoPanel";
  import ChargesParameters from "./panels/ChargesParameters";
  import CheckCharges from "./panels/CheckCharges";
  import EditDevices from "./panels/EditDevices";
  import CheckTotalCharges from "./panels/CheckTotalCharges";


  export default {
    name: "ImportChargesStage",
    components: {
      InfoPanel,
      ChargesParameters,
      CheckCharges,
      EditDevices,
      CheckTotalCharges
    },
    props: {
      importInfo: {}
    },
    data(){
      return {
        apartmentsType: 0,
        tariffs: [],
      }
    },
    methods: {
      async getTariffs(){
        try{
          let {data} = await this.$http.get('import/houses/tarifs', {
            params: {
              import_id: this.importInfo.id,
              apartments_type: this.apartmentsType
            }
          });
          this.tariffs = data;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.tariffs = []
        }
      }
    },
    created() {
      this.getTariffs();
    },
    watch: {
      apartmentsType(){
        this.getTariffs();
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-charges-stage {
    &__row {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -7.5px;
    }

    &__col {
      flex: 1;
      padding: 0 7.5px;

      &50 {
        flex: 0 0 50%;
      }

      &-content {
        margin-bottom: 15px;
      }
    }
  }

</style>
